export default __webpack_public_path__ + "static/media/grafismo-left-bottom.07fc3fab.png";